<app-tooltip-template label="select.period" *ngIf="data.attributes?.parameters?.period">
  <app-datepicker-period [period]="data.attributes.parameters.period" [compare]="data.attributes.parameters.compare?.value"></app-datepicker-period>
</app-tooltip-template>
